import React from 'react';
import styles from './LoadingOverlay.module.css';

const LoadingOverlay = ({ text = "Carregando..." }) => {
  return (
    <div className={styles.overlay}>
      <svg className={styles.svgSpinner} viewBox="0 0 50 50">
        <circle
          className={styles.svgSpinnerCircle}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="5"
        ></circle>
      </svg>
      {text && <span className={styles.text}>{text}</span>}
    </div>
  );
};

export default LoadingOverlay;